/**
 * Cart Page JavaScript
 * Handles cart quantity updates and integrates with Shopify Cart API
 */

class CartPage {
  constructor() {
    this.init();
  }

  init() {
    // Bind quantity selectors
    this.bindQuantitySelectors();

    // Bind remove links
    this.bindRemoveLinks();

    // Listen for cart updates
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));
  }

  /**
   * Bind quantity dropdown selectors to update cart
   */
  bindQuantitySelectors() {
    const quantitySelectors = document.querySelectorAll('.cart-quantity-dropdown');

    quantitySelectors.forEach(selector => {
      selector.addEventListener('change', (e) => {
        const lineKey = e.target.dataset.lineKey;
        const quantity = parseInt(e.target.value, 10);

        this.updateCartQuantity(lineKey, quantity);
      });
    });
  }

  /**
   * Bind remove links to remove items from cart
   */
  bindRemoveLinks() {
    const removeLinks = document.querySelectorAll('.cart-remove-link');

    removeLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const lineKey = e.target.dataset.cartRemove;

        if (confirm('Remove this item from your cart?')) {
          this.removeCartItem(lineKey);
        }
      });
    });
  }

  /**
   * Remove cart item by setting quantity to 0
   * @param {string} lineKey - The cart line item key
   */
  async removeCartItem(lineKey) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      });

      if (!response.ok) {
        throw new Error('Failed to remove item');
      }

      const cart = await response.json();

      // Trigger cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));

      // Reload page to show updated cart
      window.location.reload();

    } catch (error) {
      console.error('Error removing item:', error);
      alert('Failed to remove item. Please try again.');
    }
  }

  /**
   * Update cart item quantity using Shopify Cart API
   * @param {string} lineKey - The cart line item key
   * @param {number} quantity - New quantity
   */
  async updateCartQuantity(lineKey, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update cart');
      }

      const cart = await response.json();

      // Trigger cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart }
      }));

      // Reload page to show updated cart
      window.location.reload();

    } catch (error) {
      console.error('Error updating cart:', error);
      alert('Failed to update cart. Please try again.');
    }
  }

  /**
   * Handle cart update events
   * @param {CustomEvent} event
   */
  handleCartUpdate(event) {
    const cart = event.detail.cart;
    console.log('Cart updated:', cart);

    // Update cart count in header if exists
    const cartCountElements = document.querySelectorAll('.cart-count');
    cartCountElements.forEach(el => {
      el.textContent = cart.item_count;
    });
  }
}

// Initialize cart page when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CartPage();
  });
} else {
  new CartPage();
}
